import { SalesProperty } from '../../../models/reports/admin-report/sales-property.model';
import { SalesAddon } from '../../../models/reports/admin-report/sales-addon.model';
import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";

/**
 * @class SalesPropertyPmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<SalesProperty>}
 */
export class SalesPropertyPmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/sales-property';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SalesProperty}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SalesProperty(attributes);
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SalesAddon}
     * @protected
     */
    newModelAddons(attributes, ...params) {

        return new SalesAddon(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<SalesProperty>>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .then((response) => {

                response.properties = response.properties.map((attributes) => this.newModel(attributes));
                response.addons = response.addons.map((attributes) => this.newModelAddons(attributes));

                return response;
            })
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/sales-property.service.js